import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { DashboardSafeCard } from "./DashboardSafeCard";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const guideItemSx = {
    borderRadius: "12px",
    px: 1.5,
    py: 1.25,
    mx: -1.5,
    cursor: "pointer",
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    background: "transparent",
    "&:hover": {
        background: "rgba(249, 115, 22, 0.06)",
        transform: "translateX(4px)",
        "& .guide-icon": {
            color: "#ea580c",
            transform: "scale(1.12)",
        },
        "& .guide-title": {
            color: "#9a3412",
        },
    },
};

const guideIconSx = {
    color: "#c2410c",
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
};

const guideTitleSx = {
    fontWeight: 600,
    letterSpacing: "-0.01em",
    lineHeight: 1.4,
    transition: "color 280ms cubic-bezier(0.4, 0, 0.2, 1)",
};

const guideDescSx = {
    color: "#78716c",
    ml: 3.5,
    fontSize: "0.8rem",
    lineHeight: 1.55,
    letterSpacing: "0.01em",
};

const footerButtonSx = {
    mt: 2,
    borderColor: "rgba(249, 115, 22, 0.35)",
    color: "#c2410c",
    borderRadius: "10px",
    px: 2.5,
    py: 0.75,
    fontWeight: 600,
    letterSpacing: "0.01em",
    textTransform: "none",
    backdropFilter: "blur(8px)",
    background: "rgba(249, 115, 22, 0.04)",
    transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        background: "rgba(249, 115, 22, 0.1)",
        borderColor: "rgba(249, 115, 22, 0.55)",
        transform: "scale(1.02)",
        boxShadow: "0 4px 16px rgba(249, 115, 22, 0.18)",
    },
    "&:active": {
        transform: "scale(0.98)",
    },
};

export default function DashboardSafeGuides() {
    const navigate = useNavigate();
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);
    const myTeam = useSelector((state) => state.teams.myTeam);
    const teams = useSelector((state) => state.teams.teams);

    function navigateTo(view, subView = 0) {
        const selectedTeamId = selectedTeamsIds?.[0] ?? myTeam?.id ?? teams?.[0]?.id;
        navigate(`/${view}/${selectedTeamId}/${subView}`);
    }

    return (
        <DashboardSafeCard
            icon={<HelpOutlineIcon />}
            title="Guides rapides"
            accent="#f97316"
            accentSoft="rgba(249, 115, 22, 0.2)"
            
        >
            <Stack spacing={0.5}>
                <Box sx={guideItemSx} onClick={() => navigateTo("leaves")}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <ArticleOutlinedIcon className="guide-icon" sx={guideIconSx} fontSize="small" />
                        <Typography className="guide-title" variant="body2" sx={guideTitleSx}>
                            Déclarer une absence (congé, RTT, maladie)
                        </Typography>
                    </Stack>
                    <Typography variant="body2" sx={guideDescSx}>
                        3 étapes, moins d'une minute pour valider la demande.
                    </Typography>
                </Box>

                <Box sx={guideItemSx} onClick={() => navigateTo("vcomp")}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <ArticleOutlinedIcon className="guide-icon" sx={guideIconSx} fontSize="small" />
                        <Typography className="guide-title" variant="body2" sx={guideTitleSx}>
                            Répondre au questionnaire Vcomp
                        </Typography>
                    </Stack>
                    <Typography variant="body2" sx={guideDescSx}>
                        Votre avis améliore les projets et le suivi des missions.
                    </Typography>
                </Box>

                <Box sx={guideItemSx}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <ArticleOutlinedIcon className="guide-icon" sx={guideIconSx} fontSize="small" />
                        <Typography className="guide-title" variant="body2" sx={guideTitleSx}>
                            Besoin d'aide ? Contactez le support
                        </Typography>
                    </Stack>
                    <Typography variant="body2" sx={guideDescSx}>
                        Décrivez le problème et joignez une capture si possible.
                    </Typography>
                </Box>
            </Stack>
        </DashboardSafeCard>
    );
}
